import type { HelpFile } from '../../types/help'
import { RehireReviewDetailTestIds } from '../../../testids/RehireReviewDetailTestIds'

export const rehireReviewDetailHelp: HelpFile = {
  docPage: '/docs/admin/rehire-review',
  texts: {
    [RehireReviewDetailTestIds.rehireReviewDetail]:
      'Wiedereinstellungs-Prüfung im Detail — eingehender Datensatz im Abgleich mit einer bestehenden Identität, Entscheidung des Admins ausstehend.',
    [RehireReviewDetailTestIds.badgeDecidedByConnector]:
      'Der Konnektor hat diese Wiedereinstellung automatisch anhand seiner Regeln vorentschieden; der Admin bestätigt oder überschreibt.',
    [RehireReviewDetailTestIds.btnCancel]: null,
    [RehireReviewDetailTestIds.btnCreateNew]:
      'Abgleich ablehnen und eine neue Identität für den eingehenden Datensatz anlegen — geeignet, wenn der Konnektor die falsche Person zugeordnet hat.',
    [RehireReviewDetailTestIds.btnReject]:
      'Wiedereinstellung ablehnen — der eingehende Datensatz wird verworfen, keine Identität wird erstellt oder reaktiviert.',
    [RehireReviewDetailTestIds.btnResurrect]:
      'Abgeglichene Identität reaktivieren und eingehende Attribute übernehmen.',
    [RehireReviewDetailTestIds.btnSubmit]:
      'Entscheidung einreichen — kann nicht rückgängig gemacht werden.',
    [RehireReviewDetailTestIds.cardTitleRehireReviewDiff]:
      'Feld-für-Feld-Vergleich zwischen der abgeglichenen Identität und dem eingehenden Datensatz.',
    [RehireReviewDetailTestIds.colAttribute]: null,
    [RehireReviewDetailTestIds.colNewValue]:
      'Wert aus dem eingehenden Datensatz — ersetzt den gespeicherten Wert bei Reaktivierung.',
    [RehireReviewDetailTestIds.colOldValue]:
      'Aktuell auf der abgeglichenen Identität gespeicherter Wert.',
    [RehireReviewDetailTestIds.decisionInfoDecidedBy]:
      'Admin, der die Entscheidung getroffen hat, und Zeitpunkt der Entscheidung.',
    [RehireReviewDetailTestIds.entryDateError]:
      'Validierungsfehler für das Eintrittsdatum — fehlt oder liegt in der Vergangenheit.',
    [RehireReviewDetailTestIds.inputNewEntryDate]:
      'Wirksames Eintrittsdatum für die reaktivierte oder neu angelegte Identität.',
    [RehireReviewDetailTestIds.inputReason]:
      'Pflichtbegründung für die Entscheidung — wird im Audit-Protokoll erfasst.',
    [RehireReviewDetailTestIds.reasonError]:
      'Validierungsfehler für die Begründung — Pflichttext fehlt.',
    [RehireReviewDetailTestIds.rehireReviewActionBar]:
      'Verfügbare Aktionen für diese Wiedereinstellungs-Prüfung: reaktivieren, ablehnen oder neu anlegen.',
    [RehireReviewDetailTestIds.rehireReviewDecisionDialog]:
      'Erfasst die endgültige Entscheidung, das Eintrittsdatum und die Begründung vor dem Einreichen.',
    [RehireReviewDetailTestIds.rehireReviewDecisionInfo]:
      'Schreibgeschützte Zusammenfassung der für diese Prüfung getroffenen Entscheidung.',
    [RehireReviewDetailTestIds.rehireReviewDiffCard]:
      'Gegenüberstellung der abgeglichenen Identität und des eingehenden Datensatzes.',
    [RehireReviewDetailTestIds.rehireReviewIncomingCard]:
      'Eingehender Datensatz aus dem Quellsystem.',
    [RehireReviewDetailTestIds.rehireReviewMatchedCard]:
      'Bestehende Identität, die das System als mögliche Wiedereinstellung erkannt hat.',
    [RehireReviewDetailTestIds.rehireReviewReadonly]:
      'Diese Prüfung ist abgeschlossen; weitere Änderungen sind nicht möglich.',
    [RehireReviewDetailTestIds.toastOpenIdentity]:
      'Soeben reaktivierte Identität öffnen.',
    [RehireReviewDetailTestIds.toastOpenNewIdentity]:
      'Neu aus dem eingehenden Datensatz angelegte Identität öffnen.',
    [RehireReviewDetailTestIds.toastOpenMyRequests]:
      'Meine Anfragen öffnen, um die soeben für diese Wiedereinstellung eingereichten Zugriffsanfragen anzuzeigen.',
    [RehireReviewDetailTestIds.rehireReviewPreviousAccessCard]:
      'Aktuell aktive Zugriffsprofil-Zuweisungen der abgeglichenen (alten) Identität. Auswahl der Profile, die Sie für die wiedereingestellte Identität erneut anfragen möchten.',
    [RehireReviewDetailTestIds.cardTitlePreviousAccess]:
      'Überschrift der Auswahlliste für früheren Zugriff — zeigt, wessen vorheriger Zugriff aufgelistet ist.',
    [RehireReviewDetailTestIds.previousAccessSelectionCount]:
      'Aktuelle Anzahl der für die erneute Anfrage ausgewählten Profile.',
    [RehireReviewDetailTestIds.btnCreateAccessRequests]:
      'Pro ausgewähltem Profil eine Zugriffsanfrage gegen die wiedereingestellte (oder abgeglichene) Identität einreichen. Jede Anfrage durchläuft ihre eigene Genehmigungsrichtlinie — die Auswahl gewährt nie direkt Zugriff.',
  },
}
